<template>
    <div>
    <div class="container">
         <div class="row" style="margin-top: 100px;margin-bottom:20px;">
            <div class="col-md-12">
              <h3 class="text-center mb-4">常见问题</h3>
              <ul class="list-group">
                <li class="list-group-item">Q1: 孩子多大能上编程课？
    
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们比较推荐小学3-4年级开始做编程的启蒙，对应的年龄大概在9岁左右，这个年纪的学生能够理解简单的编程逻辑，慢慢培养孩子的兴趣</li>
                       
                        </ul>
                    </div>
    
    
                </li>
                <li class="list-group-item">Q2: 孩子需要什么样的基础？数学重要吗？
    
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">孩子需要能理解基本的逻辑，比如条件。需要一些数学知识，例如加减乘除，小数，等知识，学过方程等概念更好。
                                数学和编程有一定关系，但学习编程本身，并不需要太高深的数学知识。

                            </li>
                           
                        </ul>
                    </div>
    
                </li>
                <li class="list-group-item">Q3: 孩子学过奥数，有帮助吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">奥数本身和编程的体系略有不同，有一定的帮助，但并不特别直接的联系</li>
                        </ul>
                    </div>
    
                </li>
                <li class="list-group-item">Q4: 孩子学编程有用吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">孩子学习编程主要开发孩子的逻辑思维能力，解决问题的能力。能够帮助孩子建立逻辑体系，孩子除了学习以外，到了一定水平可以参加一些竞赛比赛，对升学和出国等都有帮助</li>
                        </ul>
                    </div>
    
                </li>
                <li class="list-group-item">Q5: 学习编程该学什么语言？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">如果孩子从未接触过任何编程，建议孩子可以自己接触一下或学习一下scratch这种基于拖拽块的编程方式。稍稍入门以后，Python，Java和C++都是可以作为入门学习的语言。
                                这些计算机语言从本质上来说都是一样的，讲述的内容也都大体相同。Python相对简单一些，C++相对难一些。建议以Python和Java入门。然后过渡到C++
                            </li>
                      
                        </ul>
                    </div>
                </li>
                <li class="list-group-item">Q6: 你们这里提供什么样的课程，课程形式是怎么样的？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们这里目前主要基于编程入门和编程进阶课程，有Java和C++的课程，课程形式为在线网课，通常为1对1,1对多。1对多的网课不超过3个人。您可选择报名。</li>
                      
                        </ul>
                    </div>
                </li>
                <li class="list-group-item">Q7: 整个课程的时间安排是怎样的？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们目前的Java入门课程，课时为12次课，每次1个小时。C++课程课时为16次课，每次1个小时</li>
                          
                        </ul>
                    </div>
                </li>
                <li class="list-group-item">Q8: 学完课程以后可以达到什么样的效果？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们的课程目标，Java课程学习完成之后，理解基本的程序逻辑，可以用代码编写简单的小程序，小游戏。C++课程完成后，可以更加牢靠的掌握编程的基本逻辑，掌握C++的方方面面的知识</li>
                          
                        </ul>
                    </div>
    
                </li>
                <li class="list-group-item">Q9: 学习完成以后后续还可以学习什么？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">课程学习完后，根据实际学习情况，会建议学生进行进阶学习，例如数据结构以及算法的课程。学习完成以后可以参加竞赛，比赛之类的。</li>
                        </ul>
                    </div>
    
                </li>
                <li class="list-group-item">Q10: 有试听课吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们提供免费的试听课，可添加微信获取试听课链接，试听课的主要目标在于了解学生的实际水平，也便于家长进行评估。</li>
                        </ul>
                    </div>
                </li>

                <li class="list-group-item">Q11: 上课需要安装什么软件和设备？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们上课需要电脑，Mac系统和Windows系统皆可。安装软件方面，Java入门课程只需要浏览器就可以，C++课程需要安装Lightly软件，<a target="new" href="https://lightly.teamcode.com/">下载链接</a>。
                            上课同时需要安装腾讯会议，方便课堂上教室分享桌面和演示</li>
                        </ul>
                    </div>
                </li>

                <li class="list-group-item">Q12: 上课内容有回放吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">根据需要会将课堂内容录屏，录屏内容会提供链接，学生可以回看</li>
                        </ul>
                    </div>
                </li>

                <li class="list-group-item">Q13: 需要什么参考书吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">我们上课会提供教学案例，以及教学代码，登录网页查看即可，并不需要购买额外的参考书</li>
                        </ul>
                    </div>
                </li>

                <li class="list-group-item">Q14: 课程有练习作业和考试吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">随着课程的进行，我们会将课程的作业同步发给家长，课程结束以后，也会发给考试内容，学生可以自行测试，订正答案</li>
                        </ul>
                    </div>
                </li>

                <li class="list-group-item">Q15: 课程有答疑吗？
                    <div style="font-size:14px">
                        <ul>
                            <li class="sub">学生可以随时通过微信询问老师，老师会尽快答复。如需要安排答疑课，可与我们联系。</li>
                        </ul>
                    </div>
                </li>
              </ul>
            </div>
          </div>
    
          <div class="row" style="margin-top:50px;margin-bottom:50px;">
        <div class="col-md-7">
            <img src="/images/back2.jpg" class="img-fluid" alt="Processing编程教室"></img>

        </div>
        <div class="col-md-5">
            <h3 style="margin:20px 0px">我要上课</h3>
            
            <div style="margin-bottom:20px">联系课程顾问获取课程价格以及上课方式</div>
            <div><img src="https://program.dctechonline.cn/static/images/head.jpg" style="max-width:180px"/></div>
        </div>
      </div>

      
        </div>
        <bottom></bottom>
    </div>
    </template>

    <script>
import bottom from '@/components/bottom.vue'
export default{
    components:{
        bottom
    }
}
</script>
    
    <style>
    .sub{
        list-style: none;
        color:#666;
        font-weight: normal;
        margin-top:5px;
    }
    </style>